import $ from 'jquery';

// When user shows/hides ark navigation sidebar, add/remove necessary UI elements with CSS
function toggleArkNavElements() {
    if ($('body.ark').length && $('#aside-navigation').length) {
        const $arkNav = $('#aside-navigation');
        const $navControls = $arkNav.find('.navigation__controls');
        $navControls.on('show.bs.collapse', function () {
            $(this).parents('.aside__panel')
                    .addClass('aside__panel--active');
        });
        $navControls.on('hide.bs.collapse', function () {
            $(this).parents('#aside-primary .aside__panel')
                    .removeClass('aside__panel--active');
        });
    }
}

// Old fashioned jump menu is still the best option; some manifestations have hundreds of sequences.
function jumpControl() {
    const $jumpMenu = $('#ark-jump-menu');
    const $jumpForm = $('#ark-jump');

    $jumpForm.submit((e) => {
        e.preventDefault();
        const $selectedValue = $jumpMenu.find('option:selected').val();
        window.___location.replace($selectedValue);
    });
}

// Add bootstrap tooltips to items with the -toggle="tooltip" data attribute
function dateModal() {
  $('[data-toggle="popover-date"]').popover({
      placement: 'auto left',
      container: 'body',
      content: 'This value may be approximate,represent a date-range, or have other special ' +
        'circumstances that are difficult to input and describe. Find out more about what this ' +
        'format means by clicking on the icon.',
  });
}

// Images of filesets can be variably sized and this screws with row heights & wrapping frequently.
// Calculate the smallest items height and set that for all similar images on the page.
function equalizeThumbnailHeight() {
    $(window).on('load', () => {
        const $thumbs = $('.ark__thumbnail img');
        let smallestThumb = $thumbs[0];
        let averageHeight = $(smallestThumb).height();
        $thumbs.each(function () {
            const $this = $(this);
            if ($this.height() < $(smallestThumb).height()) {
                smallestThumb = $this;
                averageHeight = $this.height();
            }
        });
    });
}

// Toggle Highlighting in fieldSet Views off/on.
function toggleHighlighting() {
    $('#toggle-highlighting').on('click', () => {
        $('div.term').toggleClass('term--off');
        event.preventDefault();
    });
}

// Toggle Highlighting colors for better contrast when image color makes reading difficult.
function toggleHighlightingColor() {
    $('#highlighter-controls').on('click', 'i', function () {
        const termClass = $(this).data('highlight');
        $('div.term').attr('class', `term ${termClass}`);
    });
}

function buildSearchResults() {
    if (typeof window.searchJSON !== 'undefined') {
        const $resultsWrapper = $('#live-results');

        $.getJSON(window.searchJSON, (data) => {
            const resultsSnippet = data.results.slice(0, 4);

            const resultsMoreLength = resultsSnippet.length;
            const $resultsMore = `<div class="row  results__action"><div class="col-xs-12">Viewing 1 - ${resultsMoreLength} of ${window.resultsLength} hits matching your query. <a href="${window.searchHTML}">View All</a>.</div></div>`;

            for (let i = 0; i < resultsSnippet.length; i++) {
                const resultThumb = `<div class="col-sm-3"><a href="${resultsSnippet[i].link_with_query}"><img class="img-thumbnail img-responsive" src="${resultsSnippet[i].link}small_res/" alt="search result thumbnail" /></a></div>`;
                const resultLink = `<h4 class="result__title"><a href="${resultsSnippet[i].link_with_query}">${sequenceString} ${resultsSnippet[i].page_number}</a></h4>`;
                const resultContent = `<p class="ark__result-text">${resultsSnippet[i].content}</p>`;
                const resultBody = `<div class="col-sm-9">${resultLink} ${resultContent}</div>`;
                const resultRow = `<div class="row  result  result--list">${resultThumb} ${resultBody}</div>`;

                $resultsWrapper.append(resultRow);
            }
            $resultsWrapper.append($resultsMore);
        });
    }
}

/*
  * When a user clicks on an alternat search option, we create a hidden form with the
  * data attributes from the clicked element and submit the form.
  * This targets elements with the class 'ark__search-option' and data attributes that
  * start with 'data-form-*' and creates hidden inputs with the data-form-* attributes.
 */
function arkSearchAlternates() {
    document.addEventListener('click', (e) => {
        const target = e.target.closest('a.ark__search-option');
        if (!target) return;

        e.preventDefault();

        const searchForm = document.querySelector('#ark-main-search-box');
        const formAction = searchForm.getAttribute('action');
        const { submitAction } = target.dataset;

        // Clean up previously created hidden forms
        document.querySelectorAll('.cloned-search-form').forEach(form => form.remove());

        // Clone the form
        const clonedForm = searchForm.cloneNode(true);

        // Remove the cloned form's ID to avoid duplicate IDs in the DOM and hide it
        clonedForm.removeAttribute('id');
        clonedForm.style.display = 'none';
        clonedForm.classList.add('cloned-search-form');

        // Remove any existing 'fq' and 't' inputs from the cloned form
        clonedForm.querySelectorAll('input[name="fq"], input[name="t"]').forEach(input => input.remove());

        // Add the 'fq' and 't' inputs from the target's data attributes
        Object.keys(target.dataset).forEach(key => {
            if (key.startsWith('form')) {
                const inputName = key.replace('form', '').toLowerCase();
                const inputValue = target.dataset[key];

                const hiddenInput = document.createElement('input');
                hiddenInput.type = 'hidden';
                hiddenInput.name = inputName;
                hiddenInput.value = inputValue;

                clonedForm.appendChild(hiddenInput);
            }
        });

        // Set the form's action to the 'data-submit-action' or fallback to the original action
        clonedForm.setAttribute('action', submitAction || formAction);

        // Append the cloned form to the body
        document.body.appendChild(clonedForm);

        // Submit the cloned form
        clonedForm.submit();
    });
}


function arkKeyBindings() {
    const keymap = {};

    // LEFT
    keymap[37] = '#prev';
    // RIGHT
    keymap[39] = '#next';

    $(document).on('keyup', (event) => {
        let href;
        const selector = keymap[event.which];
        // if the key pressed was in our map, check for the href
        if (selector) {
            href = $(selector).attr('href');
            if (href) {
                // navigate where the link points
                window.___location = href;
            }
        }
    });
}

// If there are no search results within Ark item, focus the search field when going to the fragment
function arkEmptySearchFocus() {
    if ($('body.ark').length) {
        $('#ark-context-jump-search').on('click', (e) => {
            const $insideQ = $('#inside-q');
            if ($insideQ.val() === '') {
                e.preventDefault();
                window.___location.href = '#search-inside';
                $insideQ.focus();
            }
        });
    }
}

export {
    toggleArkNavElements,
    jumpControl,
    dateModal,
    equalizeThumbnailHeight,
    toggleHighlighting,
    toggleHighlightingColor,
    buildSearchResults,
    arkSearchAlternates,
    arkKeyBindings,
    arkEmptySearchFocus,
};
